export const apiUrl = 'https://boardsapi.visionslive.com/';
export const vlqrApiUrl = 'https://api.visionslive.com/VL';
export const clientUrl = 'https://client.visionslive.com';
